import Axios from 'axios';
import { ContentLinkQueries } from '@/api/content-link/graphql/content-link.queries';
import { ContentLinkMutations } from '@/api/content-link/graphql/content-link.mutations';
import { apolloClient } from '@/apollo';
import { IContentLinkBlock } from '@/content-link/types/content-link';
import { EFetchPolicy } from '@/api/types/enums/fetch-policy';

export class ContentLinkBlockService {
  static async loadPreview(targetUrl: string): Promise<Partial<IContentLinkBlock>> {
    const {
      data: { previewContentLinkBlock },
    } = await apolloClient.query({
      query: ContentLinkQueries.previewQuery,
      variables: { targetUrl },
      fetchPolicy: EFetchPolicy.NetworkOnly,
    });
    return previewContentLinkBlock;
  }

  static async create(contentLinkBlock: IContentLinkBlock): Promise<IContentLinkBlock> {
    const {
      data: { createContentLinkBlock },
    } = await apolloClient.mutate({
      mutation: ContentLinkMutations.createMutation,
      variables: { ...contentLinkBlock },
    });
    return createContentLinkBlock;
  }

  static async update(contentLinkBlock: IContentLinkBlock): Promise<IContentLinkBlock> {
    const {
      data: { updateContentLinkBlock },
    } = await apolloClient.mutate({
      mutation: ContentLinkMutations.updateBlockMutation,
      variables: { ...contentLinkBlock },
    });
    return updateContentLinkBlock;
  }

  static async getUploadUrl(blockId: string): Promise<string> {
    const { data } = await apolloClient.query({
      query: ContentLinkQueries.uploadQuery,
      variables: { blockId },
    });
    return data.contentLinkBlockUpload;
  }

  static async uploadThumbnail({
    file,
    uploadLink,
  }: {
    file: File;
    uploadLink: string;
  }): Promise<void> {
    await Axios.put(uploadLink, file);
  }

  static async loadDetails(id: string): Promise<IContentLinkBlock> {
    const {
      data: { contentLinkBlock },
    } = await apolloClient.query({
      query: ContentLinkQueries.loadDetailsQuery,
      variables: { id },
      fetchPolicy: EFetchPolicy.NetworkOnly,
    });
    return contentLinkBlock;
  }

  static async copyContentLink(id: string): Promise<IContentLinkBlock> {
    const {
      data: { copyContentLinkBlock },
    } = await apolloClient.mutate({
      mutation: ContentLinkMutations.copyBlockMutation,
      variables: { id },
    });
    return copyContentLinkBlock;
  }

  static async loadThumbnail(id: string): Promise<Partial<IContentLinkBlock>> {
    const {
      data: { contentLinkBlock },
    } = await apolloClient.query({
      query: ContentLinkQueries.loadImageQuery,
      variables: { id },
    });
    return contentLinkBlock;
  }
}
